"use client"

import { useCodeValues } from "@/hooks/use-code-values"

/**
 * Custom hook to convert ATS source code to ATS system code
 */
export function useAtsSystemCode() {
  const { getCodeValueIdByCode, getParentId, getCodeValueCode } = useCodeValues()

  const getAtsSystemCode = (atsSource: string): string => {
    // Get the atsSource ID from the code
    const atsSourceId = getCodeValueIdByCode(atsSource, "etl.CodeAtsSource")
    if (!atsSourceId) {
      throw new Error(`ATS Source '${atsSource}' not found in etl.CodeAtsSource`)
    }

    // Get the parent ID (atsSystem ID)
    const atsSystemId = getParentId("etl.CodeAtsSource", atsSourceId)
    if (!atsSystemId) {
      throw new Error(`ATS System parent not found for ATS Source '${atsSource}'`)
    }

    // Get the atsSystem code
    const atsSystemCode = getCodeValueCode(atsSystemId, "etl.CodeAtsSystem")
    if (!atsSystemCode) {
      throw new Error(`ATS System code not found for ID ${atsSystemId}`)
    }

    return atsSystemCode
  }

  return { getAtsSystemCode }
}
